import type { Utility } from "@cs2/contracts/domain";
import { GrenadeIcon } from "../lib/grenade-icon.js";

/** Eine einzige Symbolquelle für alle Utility-Oberflächen. */
export function UtilityIcon({ type }: { type: Utility["type"] }) {
  return <GrenadeIcon type={type} />;
}
